module.exports = __webpack_public_path__ + "img/my_center_bg2.036de3e1.png";